import React from 'react';
import Modal from '@/components/shared/Modal/Modal';
import { Button } from '@/components/ui';
import { typeRole } from '@/styles/typography';

/** v1 tour welcome colors + current modal radius token. */
const TOUR_WELCOME_PANEL_CLASS =
  'pointer-events-auto !bg-gradient-to-br !from-slate-900 !via-purple-900 !to-slate-900 border border-emerald-400/40 shadow-[0_0_0_1px_rgba(16,185,129,0.25),0_0_30px_rgba(16,185,129,0.25)] ![border-radius:var(--wf-mdl-radius)]';

export function TourWelcomeModal(props: {
  isOpen: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onStart: () => void;
}) {
  const { isOpen, title, description, onClose, onStart } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      closeOnOverlayClick={false}
      footer={
        <>
          <Button type="button" variant="tertiary" size="sm" onClick={onClose}>
            Skip
          </Button>
          <Button type="button" variant="moneyIn" size="sm" onClick={onStart}>
            Start Tour
          </Button>
        </>
      }
      size="sm"
      className={TOUR_WELCOME_PANEL_CLASS}
    >
      <p className={`text-white/80 ${typeRole.caption} leading-5`}>{description}</p>
    </Modal>
  );
}
